import { useEffect, useState, useSyncExternalStore } from 'react'
import { useProgress } from '@react-three/drei'
import {
  getScenePending,
  subscribeScenePending,
} from './three/sceneReadiness'

interface ModelLoadingOverlayProps {
  logoSrc?: string
  size?: number
}

const SETTLE_MS = 250

export function ModelLoadingOverlay({
  logoSrc = '/cdn/logo.svg',
  size = 120,
}: ModelLoadingOverlayProps) {
  const { progress } = useProgress()
  const pending = useSyncExternalStore(
    subscribeScenePending,
    getScenePending,
    getScenePending
  )

  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    if (progress < 100 || pending > 0) {
      setHidden(false)
      return
    }
    const t = window.setTimeout(() => setHidden(true), SETTLE_MS)
    return () => window.clearTimeout(t)
  }, [progress, pending])

  if (hidden) return null

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 2,
        background: '#fffdf7',
      }}
    >
      <img src={logoSrc} alt="Loading" width={size} height={size} />
    </div>
  )
}
